const PUZZLE_STYLES = `
@keyframes float-particle {
  0%, 100% { transform: translateY(0) translateX(0); opacity: 0; }
  10% { opacity: 1; }
  90% { opacity: 1; }
  100% { transform: translateY(-100vh) translateX(30px); opacity: 0; }
}
@keyframes light-ray {
  0%, 100% { opacity: 0.03; }
  50% { opacity: 0.08; }
}
@keyframes scroll-unroll {
  0% { max-height: 0; opacity: 0; }
  100% { max-height: 99999px; opacity: 1; }
}
@keyframes fade-up {
  0% { opacity: 0; transform: translateY(20px); }
  100% { opacity: 1; transform: translateY(0); }
}
@keyframes seal-glow {
  0%, 100% { filter: drop-shadow(0 0 4px rgba(245,158,11,0.3)); }
  50% { filter: drop-shadow(0 0 12px rgba(245,158,11,0.7)); }
}
@keyframes completion-burst {
  0% { transform: scale(0.8); opacity: 0; }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); opacity: 1; }
}
@keyframes mastery-slide {
  0% { transform: translateX(100%); }
  100% { transform: translateX(0); }
}
@keyframes piece-snap {
  0% { transform: scale(0.5) rotate(-10deg); opacity: 0; }
  60% { transform: scale(1.15) rotate(2deg); opacity: 1; }
  100% { transform: scale(1) rotate(0); opacity: 1; }
}
@keyframes piece-idle-glow {
  0%, 100% { box-shadow: 0 0 8px var(--piece-color, rgba(217,119,6,0.3)); }
  50% { box-shadow: 0 0 20px var(--piece-color, rgba(217,119,6,0.6)), 0 0 40px var(--piece-color, rgba(217,119,6,0.2)); }
}
.puzzle-particle {
  position: absolute; width: 3px; height: 3px; border-radius: 50%;
  background: radial-gradient(circle, rgba(245,158,11,0.8), transparent);
  animation: float-particle linear infinite; pointer-events: none;
}
.scroll-unroll { animation: scroll-unroll 0.8s ease-out forwards; overflow: hidden; }
.fade-up { animation: fade-up 0.6s ease-out forwards; }
.seal-glow { animation: seal-glow 2s ease-in-out infinite; }
.completion-burst { animation: completion-burst 0.6s ease-out forwards; }
.mastery-slide-in { animation: mastery-slide 0.35s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
.piece-snap-in { animation: piece-snap 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) forwards; }
.piece-placed-glow { animation: piece-idle-glow 3s ease-in-out infinite; }
`;

if (typeof document !== 'undefined' && !document.getElementById('puzzle-styles-v4')) {
  const s = document.createElement('style');
  s.id = 'puzzle-styles-v4';
  s.textContent = PUZZLE_STYLES;
  document.head.appendChild(s);
}
